import { useState } from 'react';
import { SubmitButton } from 'components/Button/Button.styles';
import Column from "components/Grid/Column";
import Row from "components/Grid/Row";
import { useDavidApi } from 'utility/DavidApi/DavidApi';
import TextField from './FormComponents/TextField';
import Form from './FormComponents/Form';
import LoadingOverlay from 'components/Layout/MapView/LoadingOverlay/LoadingOverlay';

function EditForemanForm({
    foreman,
    hideModal
}) {
    const api = useDavidApi();
    const [inputs, setInputs] = useState({
        name: foreman.name,
        // client: foreman.client,
        email: foreman.email,
        phone: foreman.phone
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const submitHandler = async (values, id) => {
        setLoading(true);
        await api.patchForemen(values, id);

        if(hideModal) {
            setTimeout(() => {
                hideModal();
                setLoading(false);
            }, 
                1500
            );
        }
    }

    return (
      <Form 
        successMessage='Foreman updated!' 
        id={foreman.id} 
        values={inputs} 
        setValues={setInputs} 
        asyncSubmitHandler={submitHandler}
        errors={errors}
        setErrors={setErrors}
    >
    {loading && (
        <LoadingOverlay isLighter>
            <h2>
                Foreman updated! Refreshing...
            </h2>
        </LoadingOverlay>
    )}
        <TextField 
            label="Foreman Name"
            name="name"
            required
        />
        {/* <TextField
            label="Client"
            name="client"
        /> */}
        <Row gutter={15}>
        <Column width={1/2}>
                <TextField
                    label="Email"
                    name="email"
                />
            </Column>
            <Column width={1/2}>
                <TextField
                    label="Phone"
                    name="phone"
                    required
                />
            </Column>
        </Row>
        <SubmitButton>Submit</SubmitButton>
      </Form>
    )
  }

export default EditForemanForm;